import { render } from "./NavHeader.vue?vue&type=template&id=264a2d24&scoped=true"
import script from "./NavHeader.vue?vue&type=script&lang=js"
export * from "./NavHeader.vue?vue&type=script&lang=js"

import "./NavHeader.vue?vue&type=style&index=0&id=264a2d24&lang=scss&scoped=true"

import exportComponent from "D:\\Spadej Work\\SPJWEB\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264a2d24"]])

export default __exports__